import React from "react";

/* Decorative SVG pattern – gift boxes, ribbons & confetti dots in brand colors */
export default function FestivePattern() {
  return (
    <svg
      aria-hidden="true"
      className="absolute inset-0 w-full h-full"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 1200 900"
    >
      <defs>
        <pattern id="dots" x="0" y="0" width="48" height="48" patternUnits="userSpaceOnUse">
          <circle cx="3" cy="3" r="1.5" fill="#D81B8C" opacity="0.12" />
          <circle cx="27" cy="27" r="1.5" fill="#3FA535" opacity="0.12" />
        </pattern>
      </defs>

      {/* subtle dot grid background */}
      <rect width="1200" height="900" fill="url(#dots)" />

      {/* Confetti splashes */}
      <g opacity="0.85">
        {/* Big magenta circle (top-right) */}
        <circle cx="1090" cy="120" r="180" fill="#D81B8C" opacity="0.10" />
        {/* Green blob (bottom-left) */}
        <circle cx="80" cy="780" r="220" fill="#3FA535" opacity="0.10" />
        {/* Violet ring (mid-left) */}
        <circle cx="180" cy="240" r="80" fill="none" stroke="#6B2C8F" strokeWidth="6" opacity="0.18" />
        {/* Confetti rectangles */}
        <rect x="940" y="640" width="34" height="10" rx="5" fill="#D81B8C" opacity="0.35" transform="rotate(20 957 645)" />
        <rect x="280" y="560" width="34" height="10" rx="5" fill="#3FA535" opacity="0.45" transform="rotate(-15 297 565)" />
        <rect x="1020" y="380" width="34" height="10" rx="5" fill="#6B2C8F" opacity="0.4" transform="rotate(40 1037 385)" />
        <rect x="420" y="100" width="34" height="10" rx="5" fill="#D81B8C" opacity="0.35" transform="rotate(-25 437 105)" />
        <rect x="700" y="780" width="34" height="10" rx="5" fill="#3FA535" opacity="0.45" transform="rotate(10 717 785)" />

        {/* Little stars */}
        <g fill="#6B2C8F" opacity="0.35">
          <polygon points="540,180 545,196 561,196 548,206 553,222 540,212 527,222 532,206 519,196 535,196" />
        </g>
        <g fill="#D81B8C" opacity="0.30">
          <polygon points="1000,540 1005,556 1021,556 1008,566 1013,582 1000,572 987,582 992,566 979,556 995,556" />
        </g>
        <g fill="#3FA535" opacity="0.35">
          <polygon points="260,720 265,736 281,736 268,746 273,762 260,752 247,762 252,746 239,736 255,736" />
        </g>

        {/* Ribbon swirls */}
        <path
          d="M -20 460 C 150 380, 320 540, 500 460 S 820 400, 1000 470 S 1240 540, 1240 540"
          stroke="#D81B8C"
          strokeWidth="3"
          fill="none"
          opacity="0.18"
          strokeLinecap="round"
        />
        <path
          d="M -20 620 C 200 720, 380 540, 580 620 S 900 720, 1080 620 S 1240 580, 1240 580"
          stroke="#3FA535"
          strokeWidth="3"
          fill="none"
          opacity="0.18"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}
